import Axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { ACCESS_TOKEN_KEY, BACKEND_URL } from '../config';
import qs from 'qs';

// Create instance
export const AXIOS_INSTANCE = Axios.create({
    baseURL: BACKEND_URL + '/1.0',
    paramsSerializer: (params) => {
        // https://github.com/axios/axios/issues/1111
        return qs.stringify(params, { indices: false });
    },
});

// Attach JWT interceptor
AXIOS_INSTANCE.interceptors.request.use((config) => {
    try {
        const rawToken = localStorage.getItem(ACCESS_TOKEN_KEY);
        const token = rawToken ? JSON.parse(rawToken) : null;
        if (token) {
            if (!config.headers) {
                config.headers = {} as AxiosRequestHeaders;
            }
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    } catch (error) {
        console.error('Error parsing access token from localStorage', error);
    }
    return config;
});

// Orval-compatible custom instance
export function customInstance<T>(config: AxiosRequestConfig): Promise<T> {
    return AXIOS_INSTANCE(config).then(({ data }) => data);
}

export default customInstance;
